import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../AuthContext";
import { API_BASE_URL } from "../../config";
import Header from "../Header";

export default function Managerreadingdetail() {
  const { id } = useParams();
  const { logout } = useAuth();
  const [product, setProduct] = useState([]);

  const navigate = useNavigate(); // Call useNavigate to get navigate function

  const [credentials] = useState({
    token: localStorage.getItem("authToken"),
    id: id,
  });
  const fetchfirstdata = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/managerreadingdetail`,
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status) {
        setProduct(response.data.data);
      } else {
        // If status is false, show error but don't logout
        console.error("Error:", response.data.message);
        alert(
          "Error loading data: " + (response.data.message || "Unknown error")
        );
      }
    } catch (err) {
      // Only logout on authentication errors (401, 403), not on server errors
      if (
        err.response &&
        (err.response.status === 401 || err.response.status === 403)
      ) {
        logout();
        navigate("/");
      } else {
        // For other errors (500, etc.), show error message
        console.error(
          "Error loading reading details:",
          err.response?.data?.message || err.message
        );
        alert(
          "Error loading reading details: " +
            (err.response?.data?.message || err.message || "Unknown error")
        );
      }
    }
  };

  // Load saved data from local storage on component mount
  useEffect(() => {
    const authState = localStorage.getItem("authToken");
    if (authState) {
      fetchfirstdata();
    }
  }, []); // Empty dependency array means this effect runs once on mount

  const handlePrint = () => {
    window.print();
  };

   const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [stock, setStock] = useState(null);
  
    // Fetch final stock from Laravel API
    useEffect(() => {
      axios
        .get(`${API_BASE_URL}/api/final-stock`)
        .then((res) => {
          // Use this if your API returns the values directly
          // { status: true, total_production: ..., total_sales: ..., final_stock: ... }
          if (res.data.status) {
            setStock(res.data);
          } else {
            setError("Invalid response from server");
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setError("Error fetching final stock");
          setLoading(false);
        });
    }, []);

  return (
    <>
      <Header />
     
      <div className="tanker-unloading print-only">
        <div className="container">

          
          <div className="form">
            <div className="filters">
              <h3>Daily Record</h3>
            </div>

      <div className="mt-4 ">
        {loading && <p>Loading stock...</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}

        {stock && (
          <div className="stock-container">
          
            <div className="row g-3" style={{border:"none"}}>
              {/* Oil Stock */}
              <div className="col-4 col-md-4 col-lg-4">
                <div
                  className="card h-100 border-0 shadow-sm"
                  style={{
                    background:
                      "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                    borderRadius: "8px",
                  }}
                >
                  <div className="card-body p-2 p-md-3 text-center">
                    <div
                      className="mb-1"
                      style={{ fontSize: "1.2rem", color: "#0d47a1" }}
                    >
                      <i className="bi bi-droplet-fill"></i>
                    </div>
                    <h6
                      className="card-title fw-bold mb-1"
                      style={{ fontSize: "0.75rem" }}
                    >
                      OIL
                    </h6>
                    <div
                      className="stock-value"
                      style={{
                        fontSize: "1.1rem",
                        fontWeight: "700",
                        color: "#0d47a1",
                      }}
                    >
                      {parseFloat(stock.final_stock || 0).toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>

              {/* Cake Stock */}
              <div className="col-4 col-md-4 col-lg-4">
                <div
                  className="card h-100 border-0 shadow-sm"
                  style={{
                    background:
                      "linear-gradient(135deg, #fce4ec 0%, #f8bbd0 100%)",
                    borderRadius: "8px",
                  }}
                >
                  <div className="card-body p-2 p-md-3 text-center">
                    <div
                      className="mb-1"
                      style={{ fontSize: "1.2rem", color: "#880e4f" }}
                    >
                      <i className="bi bi-cake2"></i>
                    </div>
                    <h6
                      className="card-title fw-bold mb-1"
                      style={{ fontSize: "0.75rem" }}
                    >
                      CAKE
                    </h6>
                    <div
                      className="stock-value"
                      style={{
                        fontSize: "1.1rem",
                        fontWeight: "700",
                        color: "#880e4f",
                      }}
                    >
                      {parseFloat(stock.final_cake_stock || 0).toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>

              {/* Groundnut Stock */}
              {typeof stock.final_groundnut_stock !== "undefined" && (
                <div className="col-4 col-md-4 col-lg-4">
                  <div
                    className="card h-100 border-0 shadow-sm"
                    style={{
                      background:
                        "linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)",
                      borderRadius: "8px",
                    }}
                  >
                    <div className="card-body p-2 p-md-3 text-center">
                      <div
                        className="mb-1"
                        style={{ fontSize: "1.2rem", color: "#e65100" }}
                      >
                        <i className="bi-brightness-alt-high"></i>
                      </div>
                      <h6
                        className="card-title fw-bold mb-1"
                        style={{ fontSize: "0.75rem" }}
                      >
                        GROUNDNUT
                      </h6>
                      <div
                        className="stock-value"
                        style={{
                          fontSize: "1.1rem",
                          fontWeight: "700",
                          color: "#e65100",
                        }}
                      >
                        {parseFloat(stock.final_groundnut_stock || 0).toFixed(
                          2
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Bottles Stock */}
              {typeof stock.total_bottle_1l !== "undefined" && (
                <>
                  {/* 1L Bottle */}
                  <div className="col-4">
                    <div
                      className="card h-100 border-0 shadow-sm"
                      style={{
                        background:
                          "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
                        borderRadius: "8px",
                      }}
                    >
                      <div className="card-body p-2 p-md-3 text-center">
                        <div
                          className="mb-1"
                          style={{ fontSize: "1.2rem", color: "#2e7d32" }}
                        >
                          <i className="bi bi-cup-straw"></i>
                        </div>
                        <h6
                          className="card-title fw-bold mb-1"
                          style={{ fontSize: "0.7rem" }}
                        >
                          1L BOTTLE
                        </h6>
                        <div
                          className="stock-value"
                          style={{
                            fontSize: "1.1rem",
                            fontWeight: "700",
                            color: "#2e7d32",
                          }}
                        >
                          {stock.final_bottle_1l_stock || 0}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 5L Bottle */}
                  <div className="col-4">
                    <div
                      className="card h-100 border-0 shadow-sm"
                      style={{
                        background:
                          "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
                        borderRadius: "8px",
                      }}
                    >
                      <div className="card-body p-2 p-md-3 text-center">
                        <div
                          className="mb-1"
                          style={{ fontSize: "1.2rem", color: "#2e7d32" }}
                        >
                          <i className="bi bi-cup-straw"></i>
                        </div>
                        <h6
                          className="card-title fw-bold mb-1"
                          style={{ fontSize: "0.7rem" }}
                        >
                          5L BOTTLE
                        </h6>
                        <div
                          className="stock-value"
                          style={{
                            fontSize: "1.1rem",
                            fontWeight: "700",
                            color: "#2e7d32",
                          }}
                        >
                          {stock.final_bottle_5l_stock || 0}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 15L Bottle */}
                  <div className="col-4">
                    <div
                      className="card h-100 border-0 shadow-sm"
                      style={{
                        background:
                          "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
                        borderRadius: "8px",
                      }}
                    >
                      <div className="card-body p-2 p-md-3 text-center">
                        <div
                          className="mb-1"
                          style={{ fontSize: "1.2rem", color: "#2e7d32" }}
                        >
                          <i className="bi bi-cup-straw"></i>
                        </div>
                        <h6
                          className="card-title fw-bold mb-1"
                          style={{ fontSize: "0.7rem" }}
                        >
                          15L BOTTLE
                        </h6>
                        <div
                          className="stock-value"
                          style={{
                            fontSize: "1.1rem",
                            fontWeight: "700",
                            color: "#2e7d32",
                          }}
                        >
                          {stock.final_bottle_15l_stock || 0}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>

            <div className="product-form">
              <div className="row">
                <div className="col-md-3 col-4">
                  <p>Oil KG</p>
                </div>
                <div className="col-md-3 col-4">{product.oil_kg_qty}</div>
                <div className="col-md-3 col-4">{product.oil_kg_total}</div>
              </div>
            </div>
            <div className="product-form">
              <div className="row">
                <div className="col-md-3 col-4">
                  <p>Oil Letter</p>
                </div>
                <div className="col-md-3 col-4">{product.oil_ltr_qty}</div>
                <div className="col-md-3 col-4">{product.oil_ltr_total}</div>
              </div>
            </div>
            <div className="product-form">
              <div className="row">
                <div className="col-md-3 col-4">
                  <p>Oil Bottle</p>
                </div>
                <div className="col-md-3 col-4">{product.oil_bottle_qty}</div>
                <div className="col-md-3 col-4">{product.oil_bottle_total}</div>
              </div>
            </div>
            <div className="product-form">
              <div className="row">
                <div className="col-md-3 col-4">
                  <p>Cake</p>
                </div>
                <div className="col-md-3 col-4">{product.cake_qty}</div>
                <div className="col-md-3 col-4">{product.cake_total}</div>
              </div>
            </div>
            <div className="product-form">
              <div className="row">
                <div className="col-md-3 col-4">
                  <p>Grount</p>
                </div>
                <div className="col-md-3 col-4">{product.groundnut_qty}</div>
                <div className="col-md-3 col-4">{product.groundnut_total}</div>
              </div>
            </div>
            <div className="product-form">
              <div className="row">
                <div className="col-md-4 col-12  wi-33p">
                  <label>Oil KG Total Amount :{product.oil_kg_total}</label>
                </div>
                <div className="col-md-4 col-12  wi-33p">
                  <label>Oil Ltr Total Amount :{product.oil_ltr_total}</label>
                </div>

                <div className="col-md-4 col-12  wi-33p">
                  <label>Oil Bottle Amount :{product.oil_bottle_total}</label>
                </div>

                <div className="col-md-4 col-12  wi-33p">
                  <label>Cake Total Amount :{product.cake_total}</label>
                </div>
                <div className="col-md-4 col-12  wi-33p">
                  <label>Groundnut Total :{product.groundnut_total}</label>
                </div>

                <div className="col-md-4 col-12  wi-33p">
                  <label>Total Amount :{product.grandTotal}</label>
                </div>
              </div>
            </div>

            <div className="product-form">
              <div className="row">
                <div className="col-md-4 col-12 bg-green-100 rounded list-memo wi-33p">
                  <h5 className="font-bold">Credit</h5>
                  {product && product.Credits && product.Credits.length > 0 ? (
                    <>
                      {product.Credits.map((field, index) => (
                        <div key={index}>
                          <label>
                            {field.amount} /- {field.name}
                          </label>
                        </div>
                      ))}
                    </>
                  ) : (
                    ""
                  )}
                  <div className="mt-4 p-2 bg-yellow-200 text-black font-bold rounded ">
                    Total Credit Amount: {product.total_credit}
                  </div>
                </div>
                <div className="col-md-8 col-12">
                  <div className="row">
                    {/* Dynamic Input Fields for Minesh (Subtracting) */}
                    <div className="col-md-4 col-12 bg-red-100 rounded list-memo">
                      <h5 className="font-bold">Deposit Amount</h5>
                      {product &&
                      product.Deposit &&
                      product.Deposit.length > 0 ? (
                        <>
                          {product.Deposit.map((field, index) => (
                            <div key={index}>
                              <label>
                                {field.amount} /- {field.name} - {field.mode} -{" "}
                                {field.bank_name}
                              </label>
                            </div>
                          ))}
                        </>
                      ) : (
                        ""
                      )}
                      <div className="mt-4 p-2 bg-red-200 text-black font-bold rounded">
                        Total Deposit Amount: {product.total_deposit}
                      </div>
                    </div>
                    {/* Dynamic Extra (Subtracting) */}
                    <div className="col-md-4 col-12 bg-blue-100 rounded list-memo">
                      <h5 className="font-bold">Expinese</h5>
                      {product &&
                      product.Expinese &&
                      product.Expinese.length > 0 ? (
                        <>
                          {product.Expinese.map((field, index) => (
                            <div key={index}>
                              <label>
                                {field.amount} /- {field.name}
                              </label>
                            </div>
                          ))}
                        </>
                      ) : (
                        ""
                      )}
                      <div className="mt-4 p-2 bg-yellow-200 text-black font-bold rounded">
                        Total Extra Amount: {product.total_expinese}
                      </div>
                    </div>

                    <div className="col-md-4 col-12 bg-blue-100 rounded list-memo">
                      <h5 className="font-bold">Card</h5>
                      {product && product.Card && product.Card.length > 0 ? (
                        <>
                          {product.Card.map((field, index) => (
                            <div key={index}>
                              <label>
                                {field.amount} /- {field.name} {field.time}{" "}
                                {field.mode} {field.bank_name}
                              </label>
                            </div>
                          ))}
                        </>
                      ) : (
                        ""
                      )}
                      <div className="mt-4 p-2 bg-yellow-200 text-black font-bold rounded">
                        Total Card Amount: {product.total_card}
                      </div>
                    </div>

                    <div className="col-md-4 col-12 bg-blue-100 rounded list-memo">
                      <h5 className="font-bold"> Payment Outside :- </h5>
                      {product &&
                      product.Outside &&
                      product.Outside.length > 0 ? (
                        <>
                          {product.Outside.map((field, index) => (
                            <div key={index}>
                              <label>
                                {field.amount} /- {field.name}
                              </label>
                            </div>
                          ))}
                        </>
                      ) : (
                        ""
                      )}
                      <div className="mt-4 p-2 bg-yellow-300 text-black font-bold rounded">
                        Total Outside Amount: {product.total_outside}
                      </div>
                    </div>
                    <div className="col-md-4 col-12 bg-blue-100 rounded list-memo">
                      <h5 className="font-bold">Payment Inside:- </h5>
                      {product &&
                      product.Inside &&
                      product.Inside.length > 0 ? (
                        <>
                          {product.Inside.map((field, index) => (
                            <div key={index}>
                              <label>
                                {field.amount} /- {field.name}
                              </label>
                            </div>
                          ))}
                        </>
                      ) : (
                        ""
                      )}
                      <div className="mt-4 p-2 bg-yellow-300 text-black font-bold rounded list-memo">
                        <label>
                          {" "}
                          Total Inside Amount: {product.total_inside}{" "}
                        </label>
                      </div>
                    </div>
                    <div className="col-md-4 col-12 bg-blue-100 rounded list-memo">
                      <h5 className="font-bold">Bank Deposit:- </h5>
                      {product &&
                      product.Bankdeposit &&
                      product.Bankdeposit.length > 0 ? (
                        <>
                          {product.Bankdeposit.map((field, index) => (
                            <div key={index}>
                              <label>
                                {field.amount} /- {field.bank_name} -{" "}
                                {field.type} - {field.name}
                              </label>
                            </div>
                          ))}
                        </>
                      ) : (
                        ""
                      )}
                      {/* <div className="mt-4 p-2 bg-yellow-300 text-black font-bold rounded list-memo">
                        <label>
                          {" "}
                          Total Bank Deposit: {product.total_bank_deposit}{" "}
                        </label>
                      </div> */}
                    </div>
                    <div className="col-md-8 col-12 bg-blue-100 rounded ">
                      <h5 className="font-bold">Bank Statement:- </h5>
                      {product &&
                      product.bankStatement &&
                      product.bankStatement.length > 0 ? (
                        <>
                          <label className="border p-2 rounded w-1/4 col-3">
                            Bank Name
                          </label>
                          <label className="border p-2 rounded w-1/4 col-3">
                            Deposite
                          </label>
                          <label className="border p-2 rounded w-1/4 col-3">
                            Charges
                          </label>
                          <label className="border p-2 rounded w-1/4 col-3">
                            Total
                          </label>
                          {product.bankStatement.map((field, index) => (
                            <div key={index}>
                              <label className="border p-2 rounded w-1/4 col-3">
                                {field.name}
                              </label>
                              <label className="border p-2 rounded w-1/4 col-3">
                                {field.deposit}
                              </label>
                              <label className="border p-2 rounded w-1/4 col-3">
                                {field.charges}
                              </label>
                              <label className="border p-2 rounded w-1/4 col-3">
                                {field.total}
                              </label>
                            </div>
                          ))}

                          <label className="border p-2 rounded w-1/4 col-3">
                            &nbsp;
                          </label>
                          <label className="border p-2 rounded w-1/4 col-3">
                            &nbsp;
                          </label>
                          <label className="border p-2 rounded w-1/4 col-3">
                            Deposite
                          </label>
                          <label className="border p-2 rounded w-1/4 col-3">
                            {product.all_bank_total_deposite}
                          </label>

                          <label className="border p-2 rounded w-1/4 col-3">
                            &nbsp;
                          </label>
                          <label className="border p-2 rounded w-1/4 col-3">
                            &nbsp;
                          </label>
                          <label className="border p-2 rounded w-1/4 col-3">
                            Charges
                          </label>
                          <label className="border p-2 rounded w-1/4 col-3">
                            {product.all_bank_total_charges}
                          </label>

                          <label className="border p-2 rounded w-1/4 col-3">
                            &nbsp;
                          </label>
                          <label className="border p-2 rounded w-1/4 col-3">
                            &nbsp;
                          </label>
                          <label className="border p-2 rounded w-1/4 col-3">
                            Total
                          </label>
                          <label className="border p-2 rounded w-1/4 col-3">
                            {product.all_bank_bank_total}
                          </label>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="col-12 bg-blue-100 rounded">
                      <label>
                        {" "}
                        Previous day Total: {product.previous_day_total}{" "}
                      </label>
                    </div>
                    <div className="col-12 bg-blue-100 rounded">
                      <label>
                        {" "}
                        Current day Total: {product.current_day_total}{" "}
                      </label>
                    </div>
                    <div className="col-12 bg-blue-100 rounded">
                      <label> Net Total: {product.net_total} </label>
                    </div>
                    <div className="col-12 bg-blue-100 rounded ">
                      <label> Final Total: {product.final_total} </label>
                    </div>
                  </div>
                </div>
              </div>
              <button className="btn btn-primary print" onClick={handlePrint}>
                Print
              </button>
            </div>
          </div>
        </div>
      </div>
      <Header />
    </>
  );
}
